import clientAPI from "@/api/ClientAPIMixin.js";
//import Vue from "vue"
export const JobPreview = {
  namespaced: true,
  state: {
    PreviewCustomer: null,
    PreviewMachine: null,
  },
  mutations: {
    SET_PREVIEW_CUSTOMER(state, newcustomer) {
      state.PreviewCustomer = newcustomer;
    },
    SET_PREVIEW_MACHINE(state, newmachine) {
      state.PreviewMachine = newmachine;
    },
  },
  actions: {
    async selectPreviewCustomer({ commit, dispatch, state, rootGetters }) {
      const oldC = Object.assign({}, rootGetters['JobHub/JobCustomer/Customer']);
      const oldSubjobs = Object.assign([], rootGetters['JobHub/JobSubjobs/Subjobs']);
      const newC = Object.assign({}, state.PreviewCustomer);
      var result;
      if ((newC && oldC) && (newC.Id != oldC.Id) && (oldSubjobs.length > 0)) {
        var config = {
          title: "Change customer?",
          message: "Changing customer will remove all subjobs and is not reverasble. Are you still sure you want to change customer?",
        };
        result = await dispatch("ConfirmDialog/Show", config, { root: true });
      }
      else {
        result = true;
      }
      if (result) {
        dispatch('JobHub/JobCustomer/swapCustomer', newC, { root: true });
        dispatch('JobHub/JobCustomer/setDeliveryAdress', newC.DefaultDeliveryAddress, { root: true });
        dispatch('JobHub/JobCustomer/setCustomerContact', newC.DefaultCustomerPerson, { root: true });
        commit("SET_PREVIEW_CUSTOMER", null);
        return true;
      }
      else {
        return false;
      }
    },
    setPreviewCustomer({ commit }, customer) {
      commit("SET_PREVIEW_CUSTOMER", customer);
    },
    getPreviewCustomer({ dispatch }, id) {
      dispatch("setPreviewCustomer", null);
      clientAPI.methods.getCustomerById(id)
        .then((response) => {
          dispatch("setPreviewCustomer", response);
        })
        .catch((exception) => {
          console.error(exception)
          //TODO: check that this works with the error feedback
          dispatch("setPreviewCustomer", false);
        });
    },
    selectPreviewMachine({ commit, dispatch, state, rootGetters }) {
      const parentId = (rootGetters['JobHub/JobDetails'])?.Id;
      const parentBasedDefaultNoInvoice = (rootGetters['JobHub/JobDetails'])?.NoInvoice;
      const newSubjob = {
        New: true,
        Id: new Date().getTime(),
        ParentId: parentId,
        CustomerComment: null,
        SupplierFailureCodeId: null,
        NoInvoice: parentBasedDefaultNoInvoice,
        Machine: Object.assign({}, state.PreviewMachine)
      };
      dispatch('JobHub/JobSubjobs/addSubjob', newSubjob, { root: true })
      commit("SET_PREVIEW_MACHINE", null);
    },
    setPreviewMachine({ commit }, machine) {
      commit("SET_PREVIEW_MACHINE", machine);
    },
    async getPreviewMachine({ dispatch }, id) {
      await clientAPI.methods.getMachineById(id)
        .then((response) => {
          dispatch("setPreviewMachine", response);
        })
        .catch((exception) => {
          console.error(exception)
          //TODO: check that this works with the error feedback
          dispatch("setPreviewMachine", false);
        });
    },
  },
  getters: {
    PreviewCustomer: state => {
      return state.PreviewCustomer;
    },
    PreviewMachine: state => {
      return state.PreviewMachine;
    },
  },
};
